import { API_IP } from "../global_variables";

function authHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };
}

export async function initiateEtransfer(bookingId) {
  const res = await fetch(`${API_IP}/api/etransfer/initiate`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ booking_id: bookingId }),
  });
  if (!res.ok) throw new Error("Could not start e-Transfer");
  return res.json();
}

export async function fetchEtransferStatus(bookingId) {
  const res = await fetch(`${API_IP}/api/etransfer/status/${bookingId}`, {
    method: "GET",
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error("Could not load status");
  return res.json();
}

export async function cancelEtransfer(bookingId) {
  const res = await fetch(`${API_IP}/api/etransfer/cancel`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ booking_id: bookingId }),
  });
  if (!res.ok) throw new Error("Could not cancel");
  return res.text();
}
